import { render, staticRenderFns } from "./VacationsTable.vue?vue&type=template&id=6f25ff77"
import script from "./VacationsTable.vue?vue&type=script&lang=js"
export * from "./VacationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports